import Vue, { CreateElement } from 'vue'
import { Component } from 'vue-property-decorator'

import { track } from '@src/util/functions'
import { OptionGroup } from '@src/elements/select/option-group'
import { Option } from '@src/elements/select/option'
import { Select } from '@src/elements/select/select'
import SessionManager from '@src/lib/session_manager'

import './results-history.sass'

@Component
export default class ResultsHistory extends Vue {

  private selectedType: string = 'station_workouts'

  constructor () {
    super()
    track('/trainers/history')
  }

  goToHistory (type) {
    this.selectedType = type
  }

  render (h: CreateElement) {
    return <div class={SessionManager.Instance.isManager() ? 'trainer-results-history' : 'member-results-history'}>
      <Select filter={true} class='history-types' value={this.$t(`PAGE.MEMBERS.HISTORY.${this.selectedType.toUpperCase()}`)} ref='historySwitch'>
        <OptionGroup>
          <Option type='single-option' value={'station_workouts'} label={this.$t('PAGE.MEMBERS.HISTORY.STATION_WORKOUTS')} selected={this.selectedType === 'station_workouts'}
                  select={this.goToHistory} />
          {/*<Option type='single-option' value={'home'} label={this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_HOME')} selected={this.selectedType === 'home'}*/}
          {/*        select={this.goToHistory} />*/}
          <Option type='single-option' value={'training_plans'} label={this.$t('PAGE.MEMBERS.HISTORY.TRAINING_PLANS')} selected={this.selectedType === 'training_plans'}
                  select={this.goToHistory} />
        </OptionGroup>
      </Select>

      <router-view historyType={this.selectedType} />
    </div>
  }
}
